import type { ReactNode } from "react";
import { cn } from "../../lib/cn";

export function Badge({
  children,
  tone = "neutral",
}: {
  children: ReactNode;
  tone?: "neutral" | "success" | "warning" | "danger" | "info";
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-1 text-xs font-extrabold",
        tone === "neutral" && "bg-[var(--surface-high)] text-[var(--muted)]",
        tone === "success" && "bg-[#dcfce7] text-[#166534]",
        tone === "warning" && "bg-[#fef3c7] text-[#92400e]",
        tone === "danger" && "bg-[#fee2e2] text-[#991b1b]",
        tone === "info" && "bg-[#dff3ff] text-[#174d68]",
      )}
    >
      {children}
    </span>
  );
}
